var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsDirectoryPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M73.59375,49.49414c-.56152-1.0498-1.64941-1.70215-2.83984-1.70215h-5.1355c2.93567-3.87714,6.41791-9.17554,6.41791-12.50037,0-5.7464-4.65839-10.40479-10.40479-10.40479s-10.40472,4.65839-10.40472,10.40479c0,3.83521,4.63458,10.29962,7.71747,14.17542.53094.66748,1.24872,1.07074,2.00818,1.22284.16614.06342.34454.10211.5329.10211h9.26855c.03223,0,.13184,0,.19434.1167s.00684.19971-.01074.22705l-13.9502,20.8916c-.04004.06055-.1084.09668-.18164.09668h-14.43909c2.93335-3.87585,6.40662-9.16467,6.40662-12.48523,0-5.7464-4.65833-10.40479-10.40472-10.40479s-10.40479,4.65839-10.40479,10.40479c0,3.83636,4.63751,10.30359,7.72034,14.17902.69116.86884,1.69788,1.29865,2.70276,1.29327.04285.00366.08405.01294.12787.01294h18.29102c1.08008,0,2.08203-.53613,2.67773-1.43262l13.94824-20.88965c.66211-.99023.72363-2.25781.16211-3.30762ZM57.4046,35.29163c0-2.33447,1.89246-4.22693,4.22693-4.22693s4.22693,1.89246,4.22693,4.22693-1.89246,4.22693-4.22693,4.22693-4.22693-1.89246-4.22693-4.22693ZM34.14154,59.63879c0-2.33447,1.89246-4.22693,4.22693-4.22693s4.22693,1.89246,4.22693,4.22693-1.89246,4.22693-4.22693,4.22693-4.22693-1.89246-4.22693-4.22693Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsDirectoryPlaces);
export default __webpack_public_path__ + "static/media/google-maps-directory-places.775a475e4fbe8f3ef4ca452bc486f68b.svg";
export { ForwardRef as ReactComponent };